__turbopack_context__.v({
  "policy-details": "GUiqpW_policy-details",
});
